import React from "react";
import ocel from "../../images/ocel.jpg";
import zintec from "../../images/zintec.jpg";
import nehOcel from "../../images/nehrdzavejucaOcel.jpg";
import hlinik from "../../images/hlinik.jpg";
import med from "../../images/med.jpg";

const WaterJetBody = () => {
    return (
        <>
            <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6" id="intro2">
                <div className="my-4 py-4">
                    <h2 className="my-2 text-center text-3xl text-brand uppercase font-bold">Rezanie vodným lúčom</h2>

                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-brand'></div>
                    </div>
                    <h3 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-black">Presné a čísté
                        rezanie-delenie materiálov pomocou vodného lúča</h3>
                </div>
                <div className="p-2">
                    <p className="text-xl">
                        Vďaka technológii, ktorá je súčasťou našej zostavy, je naše rezanie nielen neuveriteľne presné,
                        ale
                        aj rýchlo dokončené. Z tohto dôvodu sme schopní ponúkať naše konkurenčné ceny za služby rezania
                        vodným lúčom bez toho, aby sme robili kompromisy v kvalite.
                    </p>
                    <p className="mt-4 text-xl">
                        Rezanie vodným lúčom je moderná technológia, ktorá sa využíva na presné a efektívne delenie
                        rôznych
                        materiálov. Táto metóda využíva vysokotlakový vodný lúč s abrazívnym účinkom na obrusovanie
                        materiálu. Čo sú výhody tejto technológie?
                    </p>
                </div>
                <ul className="list-disc m-4 p-8 text-xl">
                    <li className="text-brand mb-2">
                        <span className="text-black"><strong>Bez tepelného ovplyvnenia:</strong> Rezanie vodným lúčom neprodukuje tepelnú zónu,
                        čo
                        znamená, že
                        materiál
                        nie je ovplyvnený vysokými teplotami. To je dôležité pre zachovanie jeho vnútornej štruktúry
                        a
                        mechanických vlastností.</span>

                    </li>
                    <li className="text-brand mb-2">
                        <span className="text-black"><strong>Presnosť a minimálne deformácie:</strong> Rezná hrana je mimoriadne presná a bez deformácií. To je
                        obzvlášť
                            dôležité pri náročných aplikáciách, ako sú strojné diely alebo komponenty.</span>
                    </li>
                    <li className="text-brand mb-2">
                        <span className="text-black"><strong>Ekologická technológia:</strong> Rezanie vodným lúčom neprodukuje toxické odpady ani emisie. Je to
                        šetrné
                        k
                            životnému prostrediu.</span>
                    </li>
                    <li className="text-brand mb-2">
                        <span className="text-black"><strong>Široká škála materiálov:</strong> Táto technológia je vhodná pre rôzne druhy materiálov, vrátane
                        ocelí,
                            nerezu, titánu, zinku a ďalších kovov. Dokonca aj ťažkoobrobiteľné materiály sú pre ňu výzvou.</span>
                    </li>
                </ul>

                <p className='text-xl mb-8'>
                    Via informácii o technológii nájdete na tomto odkaze: <a target='_blank' rel="noopener noreferrer"
                                                                             title="Obrábanie vodným prúdom"
                                                                             className='underline  text-brand hover:text-black'
                                                                             href="https://sk.wikipedia.org/wiki/Obr%C3%A1banie_vodn%C3%BDm_pr%C3%BAdom">Obrábanie
                    vodným
                    prúdom >></a>
                </p>


                <h4 className="mt-4 mx-12 text-center text-xl font-semibold text-black"> Príklady materiálov,
                    ktoré sa dajú rezať vodným lúčom:</h4>
                <div
                    className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={ocel} className="w-max rounded-lg" alt={'Rezanie vodným lúčom - oceľ'}/>
                    </div>
                    <div
                        className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >
                        <h3 className="text-2xl  text-brand font-bold">Mäkké ocele (uhlíkové ocele)</h3>
                        <div>
                            <p className="my-3 text-xl">
                                Mäkká oceľ je jedným z najbežnejších kovov, s ktorými pracujeme, a sme radi, že môžeme
                                poskytnúť širokú škálu tried mäkkej ocele.
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={zintec} className="w-max rounded-lg" alt={'Rezanie vodným lúčom - zintec'}/>
                    </div>
                    <div
                        className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >
                        <h5 className="text-2xl  text-brand font-bold">Zintec a pozinkovaný</h5>
                        <div>
                            <p className="my-3 text-xl">
                                Pokročilá povaha našich strojov nám umožňuje rezať ocele Zintec aj pozinkované ocele.
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={nehOcel} className="w-max rounded-lg"
                             alt={'Rezanie vodným lúčom - Nehrdzavejúce ocele'}/>
                    </div>
                    <div
                        className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >
                        <h5 className="text-2xl  text-brand font-bold">Nehrdzavejúce ocele</h5>
                        <div>
                            <p className="my-3 text-xl">
                                Máme skúsenosti s prácou s rôznymi druhmi nehrdzavejúcej ocele.
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={hlinik} className="w-max rounded-lg" alt={'Rezanie vodným lúčom - Hliník'}/>
                    </div>
                    <div
                        className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >
                        <h5 className="text-2xl  text-brand font-bold">Hliník</h5>
                        <div>
                            <p className="my-3 text-xl">
                                Dokážeme rezať hliník s veľkou rýchlosťou, pričom si zachovávame vysokú kvalitu aj
                                presnosť.
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={med} className="w-max rounded-lg" alt={'Rezanie vodným lúčom - Meď'}/>
                    </div>
                    <div
                        className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >
                        <h5 className="text-2xl  text-brand font-bold">Meď</h5>
                        <div>
                            <p className="my-3 text-xl">
                                Na rozdiel od mnohých subdodávateľských spoločností zaoberajúcich sa rezaním sme schopní
                                rezať meď
                            </p>
                        </div>
                    </div>
                </div>
                <h6 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-black">Samozrejme vieme
                    rezať rôzne povrchy, všetko je na vzájomnej dohode a potrebe zákazníka.
                    Materiály Vám dokážeme dodať taktiež, prípadne môže byť aj Váš vlastný.
                </h6>
            </div>
        </>
    );
};

export default WaterJetBody;
